import { Injectable }     from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot }    from '@angular/router';
import { Cookies } from './cookies';

@Injectable()
export class AuthGuard {

    constructor(private router: Router,private cookies:Cookies) {}
    
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let url: string = state.url;
        return this.checkLogin(url);
    }
    
    checkLogin(url: string): boolean {
        if(url == "/login"){
            if(this.cookies.getCookie('ChamUserObject') != undefined){
                this.router.navigate(['/dashboard']);
                return false;
            }else{
                return true;
            }
        }else{
            if(this.cookies.getCookie('ChamUserObject') == undefined){
                this.router.navigate(['/login']);
                return false;
            }else{
                return true;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/class/auth-guard.ts